import { createClient } from '@supabase/supabase-js';

/**
 * Robust environment variable resolution.
 * We check both import.meta.env (Vite standard) and process.env (Vite define fallback).
 */
const getEnvVar = (key: string): string => {
  try {
    // Check import.meta.env first
    if (typeof import.meta !== 'undefined' && (import.meta as any).env) {
      const val = (import.meta as any).env[key];
      if (val) return val;
    }
    
    // Check process.env next (configured in vite.config.js)
    if (typeof process !== 'undefined' && process.env) {
      const val = (process.env as any)[key];
      if (val) return val;
    }
  } catch (e) {
    console.warn(`Error fetching env var ${key}:`, e);
  }
  return '';
};

const supabaseUrl = getEnvVar('VITE_SUPABASE_URL');
const internalAnonKey = getEnvVar('VITE_SUPABASE_ANON_KEY');

if (!supabaseUrl || !internalAnonKey || supabaseUrl.includes('missing-project-id')) {
  console.error(
    "Critical Error: Supabase configuration is missing or invalid.\n" +
    "Please check your .env file and ensure Vite is running correctly."
  );
}

// Initialize the Supabase client
// Using fallbacks to prevent the entire app from crashing on load
export const supabaseAnonKey = internalAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhxanFveW90Ym9vbGh0eHJ5cnpyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY5NDE5NzAsImV4cCI6MjA4MjUxNzk3MH0.s5tMJwp0SJBUoWu_UK9HdGqGztj1XJw8bDHZwCjWvYA';
export const supabase = createClient(
  supabaseUrl || 'https://hqjqoyotboolhtxryrzr.supabase.co',
  supabaseAnonKey
);